import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/product_series'
    },
    {
      path: '/account/auth_success',
      name: '微信认证',
      component: () =>
        import(/* webpackChunkName: "register" */ '@/views/auth/Auth')
    },
    {
      path: '/member/register',
      name: '会员注册',
      component: () =>
        import(/* webpackChunkName: "register" */ '@/views/merchant/Signin')
    },
    {
      path: '/member/card',
      name: '会员卡',
      component: () =>
        import(/* webpackChunkName: "register" */ '@/views/merchant/Vip')
    },
    {
      path: '/check/sn',
      name: '序列号检测',
      component: () =>
        import(/* webpackChunkName: "register" */ '@/views/merchant/Check')
    },
    {
      path: '/store',
      name: '网点',
      component: () =>
        import(/* webpackChunkName: "register" */ '@/views/merchant/StoreList')
    },
    {
      path: '/storex_bak',
      name: '网络经销商_旧',
      component: () =>
        import(/* webpackChunkName: "store2" */ '@/views/merchant/StoreListx')
    },
    {
      path: '/storex',
      name: '网络经销商',
      component: () =>
        import(/* webpackChunkName: "store2" */ '@/views/merchant/OnlineStoreList')
    },
    {
      path: '/news',
      name: '新闻列表',
      component: () =>
        import(/* webpackChunkName: "news" */ '@/views/news/NewsList')
    },
    {
      path: '/trainings',
      name: '培训列表',
      component: () =>
        import(
          /* webpackChunkName: "training" */ '@/views/training/TrainingList'
          )
    },
    {
      path: '/product_series',
      name: '产品系列',
      component: () =>
        import(
          /* webpackChunkName: "productSeries" */ '@/views/product/ProductSeries'
          )
    },
    {
      path: '/artists',
      name: '艺术家列表',
      component: () =>
        import(/* webpackChunkName: "artist" */ '@/views/artists/ArtistList')
    },
    {
      path: '/musicians',
      name: '艺术家列表',
      component: () =>
        import(/* webpackChunkName: "musician" */ '@/views/artists/ArtistList')
    },
    {
      path: '/articles/:id',
      name: '新闻详情',
      component: () =>
        import(
          /* webpackChunkName: "articleDetail" */ '@/views/detail/ArticleDetail'
          )
    },
    {
      path: '/products',
      name: '产品列表',
      component: () =>
        import(/* webpackChunkName: "product" */ '@/views/product/ProductList')
    },
    // contest
    {
      path: '/contest',
      name: '比赛海报',
      component: () =>
        import(/* webpackChunkName: "contest" */ '@/views/contest/HomePage/Poster')
    },
    {
      path: '/contest/detail',
      name: '比赛详情',
      component: () =>
        import(/* webpackChunkName: "contest" */ '@/views/contest/HomePage/HomePage')
    },
    {
      path: '/contest/charter',
      name: '比赛章程',
      component: () =>
        import(/* webpackChunkName: "contest" */ '@/views/contest/Charter')
    },
    {
      path: '/contest/news',
      name: '赛事资讯',
      component: () =>
        import(/* webpackChunkName: "contest" */ '@/views/contest/news/NewsList')
    },
    {
      path: '/contest/players/signup',
      name: '登记报名',
      component: () =>
        import(/* webpackChunkName: "contest" */ '@/views/contest/player/PlayerSignup')
    },
    {
      path: '/contest/players/work',
      name: '我的作品',
      component: () =>
        import(/* webpackChunkName: "contest_work" */ '@/views/contest/player/PrivateWork/PrivateWork')
    },
    {
      path: '/contest/players/works',
      name: '比赛作品展示',
      component: () =>
        import(/* webpackChunkName: "contest_work" */ '@/views/contest/player/Works')
    }
  ]
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js